import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/swUpdate";
import "@/lib/domGuard";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Errores no capturados: no dejar la app en blanco; guardar bitácora local
window.addEventListener("unhandledrejection", (e) => {
  const msg = String(e?.reason?.message || e?.reason || "");
  if (/ChunkLoadError|Loading chunk|dynamically imported module/i.test(msg) && !sessionStorage.getItem("chunk_reloaded")) {
    sessionStorage.setItem("chunk_reloaded", "1"); window.location.reload();
  }
});
// Service worker: la versión nueva queda en espera y la app muestra el aviso "Hay una nueva versión"
registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
